import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-confirmation-icon',
  templateUrl: './confirmation-icon.component.html',
  styleUrls: ['./confirmation-icon.component.scss']
})
export class ConfirmationIconComponent implements OnInit {
  @Input() color?:string = '#2CB45F';
  constructor() { }

  ngOnInit(): void {
  }

}
